import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-100 w-full" }
const _hoisted_2 = { class: "container mx-auto py-8" }
const _hoisted_3 = {
  key: 3,
  class: "container mx-auto px-4 sm:px-0 py-6"
}
const _hoisted_4 = { class: "grid grid-cols-1 lg:grid-cols-5 gap-4" }
const _hoisted_5 = { class: "col-span-1 lg:col-span-1" }
const _hoisted_6 = { class: "block sm:grid-cols-3 sm:grid sm:gap-2 lg:block" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ReportsForm = _resolveComponent("ReportsForm")
  const _component_ReportsSkeleton = _resolveComponent("ReportsSkeleton")
  const _component_ReportsEmpty = _resolveComponent("ReportsEmpty")
  const _component_ReportsSummary = _resolveComponent("ReportsSummary")
  const _component_CardHeader = _resolveComponent("CardHeader")
  const _component_LineChart = _resolveComponent("LineChart")
  const _component_CardContent = _resolveComponent("CardContent")
  const _component_Card = _resolveComponent("Card")
  const _component_ReportsTable = _resolveComponent("ReportsTable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_ReportsForm, {
          "onRun-search": _cache[1] || (_cache[1] = $event => (_ctx.runSearch($event)))
        })
      ])
    ]),
    (_ctx.isLoading)
      ? _createVNode(_component_ReportsSkeleton, { key: 0 })
      : _createCommentVNode("", true),
    (!_ctx.searchResults.length && !_ctx.isLoading && _ctx.hasSearched)
      ? _createVNode(_component_ReportsEmpty, {
          key: 1,
          icon: "SadIcon",
          title: "No results found.",
          text: "Try modifying your search criteria to find what your are looking for."
        })
      : _createCommentVNode("", true),
    (!_ctx.searchResults.length && !_ctx.isLoading && !_ctx.hasSearched)
      ? _createVNode(_component_ReportsEmpty, {
          key: 2,
          icon: "SearchIcon",
          title: "Nothing, yet.",
          text: "Looks like you haven't tried to run a search yet."
        })
      : _createCommentVNode("", true),
    (_ctx.searchResults.length && !_ctx.isLoading && _ctx.hasSearched)
      ? (_openBlock(), _createBlock("main", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("aside", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_ReportsSummary, {
                  title: `YTD ${_ctx.ytdValue}`,
                  amount: _ctx.ytdBalance.amount,
                  percentage: _ctx.ytdBalance.percent
                }, null, 8, ["title", "amount", "percentage"]),
                _createVNode(_component_ReportsSummary, {
                  title: "Monthly Average",
                  amount: _ctx.averageBalance
                }, null, 8, ["amount"]),
                _createVNode(_component_ReportsSummary, {
                  title: "Beginning Balances",
                  amount: _ctx.startBalance.amount,
                  text: _ctx.startBalance.month
                }, null, 8, ["amount", "text"]),
                _createVNode(_component_ReportsSummary, {
                  title: "Ending Balances",
                  amount: _ctx.endBalance.amount,
                  text: _ctx.endBalance.month
                }, null, 8, ["amount", "text"]),
                _createVNode(_component_ReportsSummary, {
                  title: "Highest Balances",
                  amount: _ctx.highestBalance.amount,
                  text: _ctx.highestBalance.month
                }, null, 8, ["amount", "text"]),
                _createVNode(_component_ReportsSummary, {
                  title: "Lowest Balances",
                  amount: _ctx.lowestBalance.amount,
                  text: _ctx.lowestBalance.month
                }, null, 8, ["amount", "text"])
              ])
            ]),
            _createVNode(_component_Card, { class: "col-span-1 lg:col-span-4 hidden sm:grid" }, {
              default: _withCtx(() => [
                _createVNode(_component_CardHeader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.year) + " Chart", 1 /* TEXT */)
                  ]),
                  _: 1
                }),
                _createVNode(_component_CardContent, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_LineChart, {
                      labels: _ctx.chartData.labels,
                      data: _ctx.chartData.datasets
                    }, null, 8, ["labels", "data"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.searchResults, (results) => {
            return (_openBlock(), _createBlock(_component_ReportsTable, {
              key: results.id,
              data: results,
              type: _ctx.type,
              "onSet-table-total": $event => (_ctx.setSummary($event, results.budget_cycle))
            }, null, 8, ["data", "type", "onSet-table-total"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}